import classNames from 'classnames';
import React from 'react';
const Layout = ({
  children,
  layoutClassName
}) => {
  const className = classNames(`${layoutClassName ?? ''}`, 'bg-slate-50', 'h-screen');
  return /*#__PURE__*/React.createElement("div", {
    "data-testid": "layout",
    className: className
  }, children);
};
export default Layout;